import { render, staticRenderFns } from "./SubAccountLogin.vue?vue&type=template&id=6bd2abd6&"
import script from "./SubAccountLogin.vue?vue&type=script&lang=js&"
export * from "./SubAccountLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports